import { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import PrivacyPolicyPage from "../../pages/privacy-policy";
import StorePolicyPage from "../../pages/store-policy";
import MyAddress from "../mypage/myAddress/MyAddress";
import AddressModal from "../mypage/myAddress/MyAddress-modal";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";

const PolicyModal = ({ setOpenPolicyModal, openPolicyModal, policy }) => {
  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return setOpenPolicyModal(false);
  };

  return (
    <>
      <Modal
        show
        size="lg"
        onHide={() => setOpenPolicyModal(false)}
        scrollable
        backdrop="static"
      >
        <ModalHeader closeButton>
          <h5> {policy == 0 ? "개인정보 처리방침" : "칼렛스토어 이용약관"}</h5>
        </ModalHeader>
        <ModalBody>
          {policy == 0 ? (
            <PrivacyPolicyPage isModal />
          ) : (
            <StorePolicyPage isModal />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};
export default PolicyModal;
